'use client';

import * as PopoverPrimitive from '@radix-ui/react-popover';
import * as React from 'react';
import { IconButton } from '../../../core-components';

// Root component for the Popover.
const Popover = PopoverPrimitive.Root;

// Trigger component for opening the Popover.
const PopoverTrigger = PopoverPrimitive.Trigger;

// Anchor component for positioning the Popover.
const PopoverAnchor = PopoverPrimitive.Anchor;

/**
 * Props for the PopoverContent component.
 */
export type PopoverContentProps = React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>;

/**
 * PopoverContent displays the content inside the popover.
 */
const PopoverContent = (props: PopoverContentProps) => {
  const {
    align = 'center',
    sideOffset = 4,
    children
  } = props;
  return <PopoverPrimitive.Portal data-sentry-element="PopoverPrimitive.Portal" data-sentry-component="PopoverContent" data-sentry-source-file="Popover.tsx">
      <PopoverPrimitive.Content align={align} side={'top'} sideOffset={sideOffset} avoidCollisions collisionPadding={16} className="z-popover w-[312px] rounded-sm bg-surface-white px-4 pb-6 pt-2 drop-shadow-md md:max-w-[232px]" data-sentry-element="PopoverPrimitive.Content" data-sentry-source-file="Popover.tsx">
        <div className="flex">
          <PopoverPrimitive.Close asChild data-sentry-element="PopoverPrimitive.Close" data-sentry-source-file="Popover.tsx">
            <IconButton iconName="cancel" variant="ghost" size="sm" className="ml-auto" aria-label="popover-close" data-sentry-element="IconButton" data-sentry-source-file="Popover.tsx" />
          </PopoverPrimitive.Close>
        </div>
        <div className="gap-2 text-marine-high-emphasis">{children}</div>
        <div className="absolute bottom-0 left-0 right-0 z-10 h-2 w-full rounded-md bg-surface-white" />
        <PopoverPrimitive.Arrow className="h-3 w-5 fill-white drop-shadow-md" data-sentry-element="PopoverPrimitive.Arrow" data-sentry-source-file="Popover.tsx" />
      </PopoverPrimitive.Content>
    </PopoverPrimitive.Portal>;
};
export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor };